import InvoiceDetailsComp from "./InvoiceDetailsComp";
import { useState } from "react";
import { Button } from "reactstrap";
import { Col, Row } from "reactstrap";
import "./InvoiceDetailsComp.css";
import { useParams } from "react-router-dom";
import { getInvoice } from "../../../../api/invoices";
import { useGetInstence } from "../../../../hooks/useGetInstence";
import { useHistory } from "react-router-dom";
import SendEmailModal from "./SendEmailModal";
import PrintInvoiceModal from "./PrintInvoiceModal";

const InvoiceDetailsPage = () => {
  const navigate = useHistory();
  const { invoiceId } = useParams();
  const [invoice, setInvoice] = useState(null);

  const { instenceLoading } = useGetInstence(
    getInvoice,
    invoiceId,
    (response) => {
      setInvoice({
        ...response.data.data.invoice,
      });
    }
  );

  const [isEmailModelOpen, setIsEmailModelOpen] = useState(false);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);

  return (
    <div className="page-content invoice-details">
      <div className="container">
        {!instenceLoading && invoice && (
          <>
            <InvoiceDetailsComp invoice={invoice} />

            <Row className="g-3">
              <Col className="print mb-5" md={12}>
                <Button
                  size="lg"
                  color="primary"
                  onClick={() => setIsPrintModalOpen(true)}
                >
                  Print
                </Button>
                <Button
                  size="lg"
                  color="primary"
                  onClick={() => setIsEmailModelOpen(true)}
                >
                  send via email
                </Button>
                <Button
                  size="lg"
                  color="primary"
                  onClick={() => navigate.push("/hours-sheet/" + invoice?.id)}
                >
                  Hours Sheet
                </Button>
              </Col>
            </Row>
          </>
        )}

        <SendEmailModal
          isOpen={isEmailModelOpen}
          handleClose={() => setIsEmailModelOpen(false)}
          invoice={invoice}
        />

        <PrintInvoiceModal
          isOpen={isPrintModalOpen}
          handleClose={() => setIsPrintModalOpen(false)}
          invoice={invoice}
        />
      </div>
    </div>
  );
};

export default InvoiceDetailsPage;
